import { render, staticRenderFns } from "./EditaCuentaEcp.vue?vue&type=template&id=24919314"
import script from "./EditaCuentaEcp.vue?vue&type=script&lang=js"
export * from "./EditaCuentaEcp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports